export default function isObjectEmpty(objectToCheck) {
  return !(!objectToCheck || Object.keys(objectToCheck).length);
}
//# sourceMappingURL=is-object-empty.js.map